import api from '@/plugins/api';

export default class {
  items = [];
  old = [];
  quota = 0;

  timer;

  constructor(parent) {
    this.parent = parent;
  }

  get total() {
    return this.items.reduce((a, i) => a + i.sum, 0);
  }

  get totalQuota() {
    return this.items.reduce((a, i) => a + i.sumTourist, 0);
  }

  get adult() {
    return this.items.reduce((a, i) => a + i.adult * i.count, 0);
  }

  get child() {
    return this.items.reduce((a, i) => a + i.child * i.count, 0);
  }

  get data() {
    return {
      TourId: this.parent.id,
      Tariffs: this.items
        .filter(i => i.count)
        .map(i => ({
          TariffId: i.value,
          SelectedCount: i.count,
        })),
    };
  }

  set({tariffs, activeQuota} = {}) {
    this.quota = activeQuota;
    this.items = tariffs.map(i => ({
      ...i.tariff,
      count: i.selectedCount,
      price: i.brutto,
      adult: i.adultCount,
      child: i.childCount,
      tourist: i.adultCount + i.childCount,
      get sumTourist() {
        return this.tourist * this.count;
      },
      get sum() {
        return this.price * this.count;
      },
    }));
    this.old = this.items.map(i => ({
      value: i.value,
      count: i.count,
    }));
  }

  submit() {
    clearTimeout(this.timer);
    return new Promise((resolve, reject) => {
      this.timer = setTimeout(() => {
        this.__submit()
          .then(resolve, reject);
      }, 1000);
    });
  }

  __submit() {
    const self = this;
    return api.tour.client
      .calculate({data: self.data})
      .then((data = {}) => {
        this.quota = data.activeQuota;
        this.items.forEach(i => {
          const old = this.old.find(j => j.value === i.value);
          old.count = i.count;
        });
        this.parent.setTariff(data);
        return this;
      })
      .catch(() => {
        this.items.forEach(i => {
          const old = this.old.find(j => j.value === i.value);
          i.count = old.count;
        });
        return Promise.reject();
      });
  }
}
